<template>
    <!--
        Bloqueos: mismo planning que el global, pero al hacer clic en una franja
        libre de la vista diaria/semanal se crea un BLOQUEO (no una cita).
    -->
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title"><i class="fas fa-ban mr-2"></i>{{ $t('general.bloqueado') }}</h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="maximize">
                                    <i class="fas fa-expand"></i>
                                </button>
                                <button type="button" class="btn btn-tool" title="Leyenda" @click="toggle">
                                    <i class="fas fa-info"></i>
                                </button>
                                <OverlayPanel ref="op">
                                    <h4 style="text-align:center">{{ $t('general.leyenda') }}</h4>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(52, 131, 171)">
                                                    {{ $t('general.operarioocupado') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(235, 235, 235)">
                                                    {{ $t('general.finalizadas') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(255, 232, 140)">
                                                    {{ $t('general.pendientes') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(0, 204, 0)">
                                                    {{ $t('general.vacaciones') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color:#476268;color:#eee;font-size:12px;">
                                                    {{ $t('general.bloqueado') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(255, 70, 70)">
                                                    {{ $t('general.porconfirmar') }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </OverlayPanel>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="alert alert-info" style="margin:8px 12px;font-size:0.85em">
                                Selecciona una franja libre en la vista diaria o semanal (o pulsa
                                <b>Nuevo bloqueo</b>) para bloquear al operario. Las citas se muestran
                                solo como referencia y no pueden modificarse desde aquí.
                            </div>
                            <div class="row">
                                <div class="fila-filtros-uniforme">
                                    <Button
                                        type="button"
                                        icon="pi pi-filter-slash"
                                        class="p-button-sm p-button-outlined btn-reinicio"
                                        style="border-radius: 8px;"
                                        title="Reiniciar Filtros"
                                        @click="reiniciarfiltros()">
                                    </Button>

                                    <MultiSelect v-model="operariosseleccionados" placeholder="Selecciona operario"
                                        :options="operariosagrupados" optionLabel="nombre" optionValue="idoperario" filter
                                        optionGroupLabel="label" optionGroupChildren="items" display="chip"
                                        :maxSelectedLabels="10" selectedItemsLabel="'{0} Operarios Seleccionados'"
                                        scrollHeight="400px" class="selector-filtro" size="small" />

                                    <select v-model="especioperarioseleccionado"
                                        class="form-control form-control-sm selector-filtro">
                                        <option value="" selected="true" hidden disabled="disabled">
                                            {{ $t('general.Selecciona Especialidad') }}</option>
                                        <option :value="especi.id_especialidad" v-for="especi in especioperario"
                                            :key="especi.id_especialidad">{{ especi.nombre }}</option>
                                    </select>

                                    <select v-if="guardias == true" v-model="guardia"
                                        class="form-control form-control-sm selector-filtro">
                                        <option selected="true" hidden disabled="disabled" value="">
                                            {{ $t('general.guardia') }}</option>
                                        <option :value="true">{{ $t('general.guardia') }} {{ $t('general.si') }}</option>
                                        <option :value="false">{{ $t('general.guardia') }} {{ $t('general.no') }}</option>
                                    </select>
                                </div>
                            </div>

                            <PlanningBloqueos v-if="operarioscargados == true"
                                :fechacal="fechacal"
                                :cambios="cambios"
                                :operarios="operarios"
                                :operariosseleccionados="operariosseleccionados"
                                :guardia="guardia" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OverlayPanel from 'primevue/overlaypanel';
import MultiSelect from 'primevue/multiselect';
import Button from 'primevue/button';
import { PwgsApi } from '../../services/PwgsApi';
import PlanningBloqueos from './bloqueos/PlanningBloqueos.vue';

export default {
    components: { OverlayPanel, MultiSelect, Button, PlanningBloqueos },
    data() {
        return {
            operarios: [],
            operariosagrupados: [],
            operariosseleccionados: '',
            operarioscargados: false,
            especioperario: '',
            especioperarioseleccionado: '',
            guardia: '',
            guardias: false,
            cambios: false,
            fechacal: null,
        };
    },
    methods: {
        toggle(event) { this.$refs.op.toggle(event); },

        reiniciarfiltros() {
            this.cambios = false;
            this.especioperarioseleccionado = '';
            this.guardia = '';
            this.operariosseleccionados = '';
        },

        async cargaroperarios() {
            const api = new PwgsApi();
            const datos = await api.post('planning-pwgs/0/operarios');
            this.operarios = Object.values(datos);
            this.operarios.sort((a, b) => a.nombre.localeCompare(b.nombre));
            const operariosgrupos = [
                { label: 'Contratados', items: [] },
                { label: 'Autónomos', items: [] },
            ];
            this.operarios.forEach(operario => {
                if (operario.tipo_operario == 'contratado') operariosgrupos[0].items.push(operario);
                else operariosgrupos[1].items.push(operario);
            });
            this.operariosagrupados = operariosgrupos;
            this.operarioscargados = true;
        },

        async cargarespecialidadesoperarios() {
            const api = new PwgsApi();
            const datos = await api.get('planning-pwgs/0/especialidades');
            this.especioperario = Object.values(datos);
            this.especioperario.sort((a, b) => a.nombre.localeCompare(b.nombre));
        },

        async comprobarGuardias() {
            const api = new PwgsApi();
            const aux = await api.get('parametros-pwgs/guardias');
            this.guardias = aux.guardias == 1;
        },

        async filtraroperarios() {
            const api = new PwgsApi();
            const subidadatos = {};
            if (this.especioperarioseleccionado) subidadatos.id_especialidad = this.especioperarioseleccionado;
            if (this.guardia === true || this.guardia === false) subidadatos.guardia = this.guardia;
            const operariosaux = await api.post('planning-pwgs/0/operarios', subidadatos);
            const aux = [];
            for (const operario of Object.entries(operariosaux)) aux.push(operario[1].idoperario);
            this.operariosseleccionados = aux;
        },
    },
    mounted() {
        this.cargaroperarios();
        this.cargarespecialidadesoperarios();
        this.comprobarGuardias();
    },
    watch: {
        especioperarioseleccionado() {
            if (this.especioperarioseleccionado) {
                this.cambios = true;
                this.filtraroperarios();
            } else {
                this.operariosseleccionados = '';
                this.cambios = false;
            }
        },
        guardia() {
            if (this.guardia === true || this.guardia === false) {
                this.cambios = true;
                this.filtraroperarios();
            } else {
                this.operariosseleccionados = '';
                this.cambios = false;
            }
        },
    },
};
</script>

<style>
.p-multiselect-items-wrapper {
    border: 1px solid;
    color: #c1c1c1;
}
</style>